/**
 * discard-all-button.tsx — Phase 049 Plan 03 Task 2 (DRAFT-04 surface 1 / D-049-06.1).
 *
 * Small "Discard all" icon button rendered in the Preview header chrome
 * alongside the dirty-count chip. Calls `useDraftStore.getState().clearAll`
 * on click. NO confirmation modal — CONTEXT D-049-06.1 is explicit: the
 * Phase 049 SoW excludes Undo/Redo, so Discard is the operator's recovery
 * path; a confirmation modal would add friction on a frequently-needed
 * action. Operator can also clear individual blocks via the per-block glyph
 * (DRAFT-04 surface 2) or Esc-on-selected (DRAFT-04 surface 3).
 *
 * Render-gated on `dirtyCount > 0` (matches the chip's gate). Mounts inside
 * the existing `aboxElementMap != null` chrome gate (D-048-03 invariant).
 *
 * T-049-03-01 — aria-label is a literal template string with the count
 * number; React escapes string children. No `dangerouslySetInnerHTML`.
 */

import { RotateCcw } from 'lucide-react'
import { useDraftStore } from '@/features/preview/store/draft-store'

export function DiscardAllButton() {
  const dirtyCount = useDraftStore((s) => s.dirtyCount())
  const clearAll = useDraftStore((s) => s.clearAll)
  if (dirtyCount === 0) return null
  return (
    <button
      type="button"
      data-testid="preview-discard-all-button"
      aria-label={`Discard all ${dirtyCount} unsaved edits`}
      onClick={clearAll}
      className="px-2.5 py-1 text-[11px] font-medium rounded bg-transparent text-muted-foreground hover:text-foreground inline-flex items-center gap-1"
    >
      <RotateCcw size={12} strokeWidth={1.7} />
      Discard all
    </button>
  )
}
